export const replaceCurrentUrl = url => window.history.replaceState({}, '', url);
//# sourceMappingURL=replaceCurrentUrl.js.map